/**
 * Deteccion de "sin espacio" y aviso proactivo de cuota baja — ver
 * docs/hallazgo-almacenamiento-fotos-offline.md, recomendaciones 1 y 2 (no
 * implementadas hasta ahora).
 *
 * Antes de esto, si IndexedDB se quedaba sin cuota al guardar una foto,
 * Dexie lanzaba `QuotaExceededError` y esa excepcion no se capturaba en
 * ningun lado especifico — quedaba como una falla generica o silenciosa,
 * sin decirle a la persona "se quedo sin espacio".
 */

/**
 * Dexie generalmente propaga el DOMException original con su `.name`
 * intacto, pero en algunos casos lo envuelve — revisamos ambos niveles para
 * no perder el caso envuelto.
 */
export function esErrorDeCuotaLlena(err: unknown): boolean {
  if (err instanceof DOMException && err.name === 'QuotaExceededError') return true
  if (err instanceof Error) {
    if (err.name === 'QuotaExceededError') return true
    const interno = (err as { inner?: unknown }).inner
    if (interno instanceof DOMException && interno.name === 'QuotaExceededError') return true
    if (interno instanceof Error && interno.name === 'QuotaExceededError') return true
  }
  return false
}

/** Mensaje unico y consistente para mostrar cuando se detecta cuota llena. */
export const MENSAJE_SIN_ESPACIO =
  'Sin espacio de almacenamiento en este dispositivo. Libera espacio o conecta a internet para sincronizar lo pendiente antes de seguir capturando.'

/**
 * Chequeo proactivo con `navigator.storage.estimate()` — no espera a que
 * falle un guardado para avisar, se puede llamar cada tanto (por ejemplo al
 * abrir la pantalla de captura) para mostrar un aviso antes de que sea un
 * problema real.
 */
export async function espacioLibreBajo(umbralMB = 50): Promise<boolean> {
  if (!navigator.storage?.estimate) return false
  try {
    const { quota, usage } = await navigator.storage.estimate()
    if (quota === undefined || usage === undefined) return false
    const libreMB = (quota - usage) / (1024 * 1024)
    return libreMB < umbralMB
  } catch {
    return false
  }
}
